// extracted by css-extract-rspack-plugin
export default {"container":"container-td88JA"};// extracted by css-extract-rspack-plugin
export default {"container":"container-td88JA"};